import React from 'react'
import { SparklesIcon } from '@heroicons/react/24/outline'
import { BULK_OFFERS } from '../data/products'

const BulkOffersBanner = ({ className = '' }) => (
  <div className={`rounded-2xl border border-primary-200 bg-gradient-to-r from-primary-50 to-green-50 p-5 ${className}`}>
    <div className="flex items-start gap-3">
      <SparklesIcon className="w-6 h-6 text-primary-600 flex-shrink-0 mt-0.5" />
      <div className="space-y-2 text-sm text-gray-800">
        <p className="font-bold text-primary-800">Bulk discount offers</p>
        <p>
          <strong>Buy any {BULK_OFFERS.freeEngravingMinBoxes} boxes</strong> and receive{' '}
          <strong>free engraving</strong> on your order (mix &amp; match allowed).
        </p>
        <p>
          <strong>Buy {BULK_OFFERS.freeBoxMinBoxes} boxes</strong> and receive{' '}
          <strong>1 complimentary box</strong> of Regular White Ultrasoft Bamboo Toothbrushes (mix &amp; match allowed).
        </p>
      </div>
    </div>
  </div>
)

export default BulkOffersBanner
